module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-422.42e11d3.woff2";